module.exports = __webpack_public_path__ + "static/img/2724_phase_function_Paper_PointsHejduk_Prediction.22d5c3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2724_phase_function_Paper_PointsHejduk_Prediction.png
// module id = QMeq
// module chunks = 0